export default [
    {
      path: '/logout',
      name: 'logout',
      component: () => import('@/views/sft/Logout.vue'),
    },
  ]